import React from 'react';
import { connect } from 'react-redux';
import { create } from './../Actions/managers';
import AddNewsView from '../Components/Manager/Item';
import Routes from './../Shared/routes';
import { IManagerEdit } from '../Shared/interfaces';
import { isEmailValid } from '../Shared/utils';
import { EMAIL_IS_INVALID, ERROR_MESSAGES, FILL_PARAMS_ERROR } from '../Shared/errors';


interface IProps {
    isLoading: boolean;
    error: number;
    create: (data: IManagerEdit) => void;
    history: any;
}

interface IState {
    error: number | null;
}

class AddNewsPage extends React.Component<IProps, IState> {

    state = {
        error: null
    }

    onSubmit = async (data: IManagerEdit) => {
        if (!data.firstName || !data.lastName || !data.email || !data.password) {
            this.setState({
                error: FILL_PARAMS_ERROR
            });
        }
        else if (!isEmailValid(data.email)) {
            this.setState({
                error: EMAIL_IS_INVALID
            });
        }
        else {
            await this.props.create(data);
            if (!this.props.error) {
                this.props.history.push(Routes.MANAGER_LIST)
            }
        }
    }

    render() {
        return (
            <AddNewsView
                error={this.props.error || this.state.error}
                isLoading={this.props.isLoading}
                onSubmit={this.onSubmit}
            />
        );
    }
}

function bindAction(dispatch: any) {
    return {
        create: (data: IManagerEdit) => dispatch(create(data)),
    };
}

const mapStateToProps = (state: any) => {
    return {
        isLoading: state.manager.isLoading,
        error: state.manager.error
    }
}

export default connect(
    mapStateToProps,
    bindAction
)(AddNewsPage);
